import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getContentTypeLabel, resolveGameContentType } from "../utils/contentType";
import { userSlice } from "../redux/user/userSlice";
import {
  deleteGame,
  getGamesData,
  deleteAccaunt,
  saveGame,
} from "../redux/asyncThunk/userActions";
import { stripSchemeTransient, FIRST_SCENE_GROUP_ID } from "./nodes/schemeLayout";
import NewGame from "./NewGame";
import AppDialogShell from "./AppDialogShell";
import ConfirmDeleteModal from "./ConfirmDeleteModal";

const { closeDialog } = userSlice;

export default function Dialog() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedGameId = useSelector((state) => state.user?.selectedGameId);
  const game = useSelector((state) => state.user?.game);
  const user = useSelector((state) => state.user?.data?.user);
  const { type, data: dialogData } = useSelector((state) => state.user?.showDialog);

  const handleClose = () => dispatch(closeDialog());

  const handleDeleteScene = () => {
    const groupId = dialogData?.groupId;
    if (!groupId || !game?.nodes || groupId === FIRST_SCENE_GROUP_ID) return;

    const deleteIds = new Set([groupId]);
    game.nodes.forEach((node) => {
      if (node.parentId === groupId) deleteIds.add(node.id);
    });

    const updateNodes = game.nodes.filter((node) => !deleteIds.has(node.id));
    const updateEdges =
      game.edges?.filter(
        (edge) => !deleteIds.has(edge.source) && !deleteIds.has(edge.target),
      ) ?? [];

    dispatch(
      saveGame({
        selectedGameId: game._id,
        nodes: stripSchemeTransient(updateNodes),
        edges: updateEdges,
      }),
    );
    dispatch(closeDialog());
  };

  if (type === "new") {
    return (
      <AppDialogShell onClose={handleClose}>
        <NewGame />
      </AppDialogShell>
    );
  }

  if (type === "delete") {
    const projectLabel = game
      ? getContentTypeLabel(resolveGameContentType(game)).toLowerCase()
      : "проект";
    const projectTitle = game?.title ?? "без названия";

    return (
      <ConfirmDeleteModal
        open
        title="Удалить проект?"
        message={`Вы хотите удалить ${projectLabel} «${projectTitle}».`}
        detail="Проект и все связанные файлы будут удалены без возможности восстановления."
        onClose={handleClose}
        onConfirm={() => {
          const onSucces = () => {
            dispatch(getGamesData({ id: user.id }));
            navigate("/main", { replace: true });
          };
          dispatch(
            deleteGame({
              userId: user.id,
              id: selectedGameId,
              onSucces,
            }),
          );
        }}
      />
    );
  }

  if (type === "delete-scene") {
    return (
      <ConfirmDeleteModal
        open
        title="Удалить сцену?"
        message="Сцена и все её кнопки будут удалены."
        detail="Связи с другими сценами также будут удалены. Это действие нельзя отменить."
        onClose={handleClose}
        onConfirm={handleDeleteScene}
      />
    );
  }

  if (type === "delete-accaunt") {
    return (
      <ConfirmDeleteModal
        open
        title="Удалить аккаунт?"
        message="Вы хотите удалить аккаунт и все данные."
        detail="Мы удалим ваш аккаунт, все созданные проекты и загруженные файлы без возможности восстановления."
        onClose={handleClose}
        onConfirm={() => {
          const onSucces = () => {
            navigate("/", { replace: true });
          };
          dispatch(
            deleteAccaunt({
              userId: user.id,
              onSucces,
            }),
          );
        }}
      />
    );
  }

  return null;
}
